<script>
import Label from "../form-components/Label.vue";
import Multiselect from "vue-multiselect";

export default {
  props: {
    item_key: {
      type: String,
      required: true,
    },
    item_value: {
      // type: String,
      required: false,
    },
    item: {
      type: Object,
      required: true,
    },
    submitted: {
      type: Boolean,
      required: true,
    },
    validation: {
      type: Object,
      required: true,
    },
    last_updated: {
      type: Object,
      required: false,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    updateValue: {
      type: Function,
      required: true,
    },
  },
  components: {
    Label,
    Multiselect,
  },
  data() {
    return {
      value: this.item_value,
      // options: this.item.options,
      options: [
        {
          title: "Privacy",
          src: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/info_pages/privacy.svg",
        },
        {
          title: "Pages",
          src: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/info_pages/pages.svg",
        },
        {
          title: "Opening Hours",
          src: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/info_pages/opening_hours.svg",
        },
        {
          title: "Documents",
          src: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/info_pages/documents.svg",
        },
        {
          title: "Alerts",
          src: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/info_pages/alerts.svg",
        },
        {
          title: "Doctor",
          src: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/info_pages/staff-availability.svg",
        },
        {
          title: "Health | Wellbeing",
          src: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/info_pages/health_wellbeing_1.svg",
        },
        // {
        //   title: "Health Campaigns",
        //   src: "https://patientlink-uploads.s3.eu-west-2.amazonaws.com/info_pages/pcn-info.svg",
        // },
      ],
    };
  },
  computed: {
    display_none_check: {
      get: function () {
        return this.selectedItem
          ? this.selectedItem[this.item.displayOn] == this.item.displayOnValue
            ? true
            : false
          : false;
      },
      set: function (newValue) {
        return newValue;
      },
    },
  },
  watch: {
    last_updated: {
      handler(val) {
        if (val && this.item.displayOn && val.key == this.item.displayOn) {
          this.display_none_check =
            val.value == this.item.displayOnValue ? true : false;
        }
      },
      deep: true,
    },
    item_value: {
      handler(val) {
        this.value = this.options.filter((x) => x.title == val.title)[0];
      },
      deep: true,
    },
    value(val) {
      if (val) {
        this.updateValue(this.item_key, val);
      }
    },
  },
};
</script>
<template>
  <div
    class="mb-3"
    :class="{ 'd-none': item.displayOn && !display_none_check }"
  >
    <Label :item="item" />
    <multiselect
      track-by="title"
      label="title"
      v-model="value"
      :options="options"
      :searchable="options.length > 5 ? true : false"
      :close-on-select="true"
      :show-labels="false"
      :placeholder="item.placeholder"
      :allow-empty="true"
      :preselectFirst="false"
    >
      <template slot="singleLabel" slot-scope="{ option }">
        <span class="option__desc">
          <span class="option__title">{{ option.title }}</span>
        </span>
      </template>
      <template slot="option" slot-scope="{ option }" class="d-flex bg-light">
        <img
          class="option__image"
          :src="option.src"
          alt="Icon"
          style="height: 2em"
        />
        <div class="option__desc pt-3">
          <span class="option__title">{{ option.title }}</span>
        </div>
      </template>
    </multiselect>
    <div v-if="submitted && validation.$error" class="invalid-feedback">
      <span v-if="!validation.required">This value is required.</span>
    </div>
  </div>
</template>
